import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useCalculateSummaryUnassignedShifts } from 'modules/shift_management/hooks/useCalculateSummaryUnassignedShifts'
import { useUnassignedShifts } from 'modules/shift_management/hooks/useUnassignedShifts'

const SummaryTotals = () => {
  const [unassignedShifts] = useUnassignedShifts()

  const [isTooltipTimeOpen, toggleTooltipTime] = useToggle(false)
  const [isTooltipCounterOpen, toggleTooltipCounter] = useToggle(false)

  const { totalTime, totalCounters } = useCalculateSummaryUnassignedShifts({
    unassignedShifts: unassignedShifts,
  })

  return (
    <Box flexDirection="row" alignItems="center" gap="s8" justifyContent="flexEnd" width="s200">
      <Box
        flexDirection="row"
        alignItems="center"
        gap="s2"
        onMouseEnter={toggleTooltipTime(true)}
        onMouseLeave={toggleTooltipTime(false)}
      >
        <Icon.Tiny icon="clock" color="grey700" />
        <Tooltip.Alt
          open={isTooltipTimeOpen}
          attachment="bottom center"
          label={i18n.t('shift_management.coverage_section.time_summary')}
        >
          <Box>
            <Text size="100" weight="bold" color="grey700">
              {totalTime}
            </Text>
          </Box>
        </Tooltip.Alt>
      </Box>

      <Box
        flexDirection="row"
        alignItems="center"
        gap="s2"
        onMouseEnter={toggleTooltipCounter(true)}
        onMouseLeave={toggleTooltipCounter(false)}
      >
        <Icon.Tiny icon="person" color="grey700" />
        <Tooltip.Alt
          open={isTooltipCounterOpen}
          attachment="bottom center"
          label={i18n.t('shift_management.coverage_section.counter_summary')}
        >
          <Box>
            <Text size="100" weight="bold" color="grey700">
              {totalCounters}
            </Text>
          </Box>
        </Tooltip.Alt>
      </Box>
    </Box>
  )
}

export default SummaryTotals
